module.exports = __webpack_public_path__ + "static/developer-hero-67f2582ebf6bf0e84be70c12448a7b55.png";